// projectAtomsEnum — 0ad3e318296ba58f833069da2289d104de9a1eb9fbd3f3d86eb1cc6362b336f8
/**
 * Project atom type enum (codegen).
 */

export enum Atoms {
  ImportProtocol = "ImportProtocol",
  OrderInfo = "OrderInfo",
  OrderPositions = "OrderPositions",
  PositionInfo = "PositionInfo",
  PresetInfo = "PresetInfo",
  PresetList = "PresetList",
  PriceData = "PriceData",
  PriceParameters = "PriceParameters",
  RecentImports = "RecentImports",
  UserOptionInfo = "UserOptionInfo",
  UserOptionsList = "UserOptionsList",
}
